var $d8e2640a066567a9$exports = {};
$d8e2640a066567a9$exports = {
    "breadcrumbs": `Navigasjonsstier`
};


export {$d8e2640a066567a9$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
